import { Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {environment } from '../../../environments/environment'
@Component({
  selector: 'app-help-desk',
  templateUrl: './help-desk.component.html',
  styleUrls: ['./help-desk.component.scss'],
})
export class HelpDeskComponent {
  @ViewChild('menu', { static: false }) menuRef!: ElementRef;
  @ViewChild('videoPlayer') videoPlayer: any;
  display: boolean = false;
  faq: boolean = false;
  driverWeb: boolean = false;
  isActive: boolean = false;
  driverMobile: boolean = true;
  selectedVideo: string = '';
  activeIndex: number = 0;
  categoryActiveIndex: number = 0;
  signup: boolean = true;
  reserveSpot: boolean = false;
  promoCode: boolean = false;
  payments: boolean = false;
  cancellation: boolean = false;
  credits: boolean = false;
  accounts: boolean = false;
  isClicked : boolean = false;
  presentComponent:number = 3;
  driverWebVedioLists = [
    {
      "title": "How to sign up?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_sign_up.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_sign_up.pdf`,
    },
    {
      "title": "How to sign up with promotion code?",
      "category" : 'Payment',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_sign_up_with_promotion_code.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_sign_up_with_promotion_code.pdf`,
    },
    {
      "title": "How to initiate a one-time booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_Initiate_a_One-time_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_initiate_a_one-time_booking.pdf`,
    },
    {
      "title": "How to initiate a recurring booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_Initiate_a_recurring_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_initiate_a_recurring_booking.pdf`,
    },
    {
      "title": "How to apply promotion code while booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_apply_promotion_code_while_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_apply_promotion_code_while_booking.pdf`,
    },
    {
      "title": "How to use the credit points?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_use_the_credit_points.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_use_the_credit_points.pdf`,
    },
    {
      "title": "How to use credit/debit card for payment?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}/Driver_Web/How_to_use_creditdebit_card_for_payment.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_use_credit_debit_card_for_payment.pdf`,
    },
    {
      "title": "How to use US bank for payment?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_use_US_bank_for_payment.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_use_US_bank_for_payment.pdf`,
    },
    {
      "title": "How to cancel a booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Web/How_to_cancel_a_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Web/Workflows/How_to_cancel_a_booking.pdf`,
    }
  ]
  driverMobileVedioLists = [
    {
      "title": "How to sign up?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_sign_up.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_sign_up.pdf`,
    },
    {
      "title": "How to sign up with promotion code?",
      "category" : 'Payment',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_sign_up_with_promotion_code.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_sign_up_with_promotion_code.pdf`,
    },
    {
      "title": "How to initiate a one-time booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_initiate_a_one-time_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_initiate_a_one-time_booking.pdf`,
    },
    {
      "title": "How to initiate a recurring booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_initiate_a_recurring_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_initiate_a_recurring_booking.pdf`,
    },
    {
      "title": "How to apply promotion code while booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_apply_promotion_code_while_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_apply_promotion_code_while_booking.pdf`,
    },
    {
      "title": "How to use the credit points?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_use_the_credit_points.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_use_the_credit_points.pdf`,
    },
    {
      "title": "How to use credit/debit card for payment?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_use_creditdebit_card_for_payment.mp4`,
      "pdfLink": `${environment.videoUrlLink}/Driver_Mobile/Workflows/How_to_use_creditdebit_card_for_payment.pdf`,
    },
    {
      "title": "How to use US bank for payment?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_use_US_bank_for_payment.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_use_US_bank_for_payment.pdf`,
    },
    {
      "title": "How to cancel a booking?",
      "category" : 'Offers',
      "vedioUrl": `${environment.videoUrlLink}Driver_Mobile/How_to_cancel_a_reservation.mp4`,
      "pdfLink": `${environment.videoUrlLink}Driver_Mobile/Workflows/How_to_cancel_a_booking.pdf`,
    }
  ]

  constructor(
    private readonly router: Router,
    private readonly renderer: Renderer2
  ) { }

  showVideo() {
    this.display = true;
  }

  toggleIcon() {
    this.isActive = !this.isActive;
  }

  showDialog(video: string) {
    this.selectedVideo = video;
    this.display = true;
    setTimeout(() => {
      this.playVideo();
    }, 0);
  }

  playVideo() {
    if (this.videoPlayer?.nativeElement) {
      this.renderer.setProperty(this.videoPlayer.nativeElement, 'autoplay', true);
      this.videoPlayer.nativeElement.play();
    }

  }

  hideDialog() {
    this.display = false;
    this.selectedVideo = '';
  }

  setActiveTab(index: number) {
    this.activeIndex = index;
    this.driverMobile = index === 0;
    this.driverWeb = index === 1;
    this.faq = index === 2;
  }

  setActiveCategoryLink(index: number) {
    this.categoryActiveIndex = index;
    this.signup = index === 0;
    this.reserveSpot = index === 1;
    this.promoCode = index === 2;
    this.payments = index == 3;
    this.cancellation = index == 4;
    this.credits = index == 5;
    this.accounts = index == 6;
  }

  navigateToContactUs() {
    this.router.navigate(['']).then(() => {
      setTimeout(() => {
        const element = document.getElementById('managerForm');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    });
  }

  navigateToHome() {
    this.router.navigate(['']);
  }
  clickMenu(event: Event) {
    event.stopPropagation();
    this.isClicked = !this.isClicked
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const clickedInside = this.menuRef?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isClicked = false;
    }
  }
}

